import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.6407 3.46427L20.4551 0.336636C19.988 -0.124024 19.2335 -0.111901 18.7665 0.373004L0.347306 19.3328C0.119762 19.551 0 19.8541 0 20.1814V23.0181C0 23.6848 0.538922 24 1.1976 24H3.94012C4.2515 24 4.5509 23.9879 4.77845 23.7697L23.6407 5.17356C24.1198 4.70078 24.1198 3.93706 23.6407 3.46427ZM20.1198 5.513L5.28144 20.5329C4.81437 21.0057 4.05988 21.0057 3.59281 20.5329C3.12575 20.0601 3.12575 19.2964 3.59281 18.8236L18.4311 3.80371C18.8982 3.33092 19.6527 3.33092 20.1198 3.80371C20.5868 4.27649 20.5868 5.04021 20.1198 5.513Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
